// Codecs the browser claims but cannot decode. Chromium without hardware
// acceleration (an option in Discord) still says yes to HEVC; the video
// then never plays. Such codecs are no longer asked for, so the server
// sends its H.264 transcode.
export const undecodable = new Set<'hevc' | 'av1'>()

/** Tells whether video decoding has hardware acceleration (Discord knows). */
export function setHardwareDecoding(enabled: boolean) {
  if (!enabled) undecodable.add('hevc')
}

/** The codec of a copied stream that could fall back to the transcode. */
export function fallibleCodec(codec: string | undefined): 'hevc' | 'av1' | null {
  if (codec?.startsWith('hvc1') || codec?.startsWith('hev1')) return 'hevc'
  if (codec?.startsWith('av01')) return 'av1'
  return null
}
